import React from "react";
import isMobile from "~/hooks/isMobile";

import BannerDeskEncerrado from "~/assets/img/banner-desk-encerrado.png";
import BannerMobileEncerrado from "~/assets/img/banner-mobile-encerrado.png";

import BannerDeskNaoIniciado from "~/assets/img/banner-desk-nao-iniciado.png";
import BannerMobileNaoIniciado from "~/assets/img/banner-mobile-nao-iniciado.png";

import BannerDesk from "~/assets/img/banner-desk.png";
import BannerMobile from "~/assets/img/banner-mobile.png";
import { useHistory  } from "react-router-dom";
import promoIsActive from "~/utils/promoIsActive";
import promoHasStarted from "~/utils/promoHasStarted";

import * as S from "./styles";

export default function HeroBanner() {
  const mobile = isMobile();
  const history = useHistory();

  const handleHeroBannerClick = () => {
    history.push("/cadastre-se");
  };

  
  const getBannerImage = () => {
    if (promoIsActive()) {
      return mobile ? BannerMobile : BannerDesk;
    } else if (!promoHasStarted()) {
      return mobile ? BannerMobileNaoIniciado : BannerDeskNaoIniciado;
    } else {
      return mobile ? BannerMobileEncerrado : BannerDeskEncerrado;
    }
  };
  return (
    <S.BannerHolder id="banner" onClick={handleHeroBannerClick} style={{ cursor: "pointer" }}>
      <S.BannerImage src={getBannerImage() }/>
      {/* <div>
        <strong>Imagens meramente ilustrativas.</strong>
        <span>
          Participação para maiores de 18 anos, com CPF válido e residentes no
          Brasil, de 15/04/2024 a 15/07/2024. *Promoção sujeita à limitação de
          estoque de vouchers e será encerrada antecipadamente caso se esgote.
          Na compra de R$ 150,00 (cento e cinquenta reais) em produtos
          participantes da Kenvue em um único cupom fiscal, o consumidor terá
          direito a receber 1 voucher no valor de R$ 50,00 (cinquenta reais)
          para utilização no e-commerce da marca LUPO® ou nas lojas físicas
          LUPO® participantes. Limite de 1 voucher por CPF. Antes de participar
          consulte demais informações, produtos participantes, condições de
          distribuição, estoque e descrição da premiação, número do Certificado
          de Autorização SPA/ME Nº 2.033232/2024 e demais informações no
          Regulamento disponível aqui. Imagens ilustrativas. GUARDE O CUPOM
          FISCAL.
        </span>
      </div> */}
    </S.BannerHolder>
  );
}
